export default __webpack_public_path__ + "static/media/stockx.07d5e0fd.svg";